export const environment = {
  production: false,
  apiUrl: "https://spear-mint.getpass.ph/"
};
